<zah-upsert-therapeut
  okLabel="Voeg toe"
  (cancelClicked)="onCancelClicked()"
  (okClicked)="onAddClicked($event)">
</zah-upsert-therapeut>
